'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import SharedApp from 'shared/pages/_app';
import '@fontsource/open-sans/latin.css';
import '@fontsource/montserrat/latin.css';
import '../stylesheets/main.scss';
import CookiesContextProvider from 'shared/contexts/CookiesContext';
import PlausibleTracking from 'shared/components/tracking/PlausibleTracking';
import Tracking from '../components/tracking';

const WrappedApp = ({ children }: { children: React.ReactNode }) => (
  <>
    <CookiesContextProvider>
      <SharedApp>{children}</SharedApp>
      <Tracking />
    </CookiesContextProvider>
    <PlausibleTracking />
  </>
);
export default WrappedApp;
